<style lang="less" scoped>
    .bread-crumb-container {
        // padding-left: 24px;
        .crumb-title {
            font-size: 14px;
            font-weight: 400;
            line-height: 64px;
        }
        .right-icon-div {
            width: 24px;
            height: 64px;
        }
        .c-pointer{
            cursor: pointer;
        }
    }
</style>

<template>
    <div class="bread-crumb-container flex">
        <el-breadcrumb separator-class="el-icon-caret-right">
            <template v-for="(b,i) in bConfigList">
                <el-breadcrumb-item v-if="b.type == 'router'" :key="i" :to="{ name: b.router }">{{b.name}}</el-breadcrumb-item>
                <el-breadcrumb-item v-else :key="i">{{b.name}}</el-breadcrumb-item>
            </template>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        name:'ZDBreadCrumb',
        props:['bConfigList'],
        data() {
            return {
            }
        },
        methods: {
            toRouter(router) {
                this.$router.push({
                    name:router
                })
            },
            // 名称处理
            getName(bName){
                if(bName == '新增'  && this.$store.state.editId){
                    return '编辑';
                }
                return bName;
            }
        },
        mounted() {
        },
        computed:{
            // bConfigList(){
            //     return this.$store.state.breadCrumbList;
            // }
        }
    }
</script>